export default [
  {
    fileName: "client/banner_recommend_2.png",
    link: "https://upromania.ro/recomanda/?utm_source=uponline&utm_medium=banner&utm_campaign=Recomanda",
    category: "Banner",
    action: "Click",
    label: "Client_Recomanda",
  },
  {
    fileName: "client/vn-dejun2.png",
    link: "https://upromania.ro/utile/legislatie/ordin-484-280-2025/",
    category: "Banner",
    action: "Click",
    label: "Client_vn_dejun",
  },
  // {
  //   fileName: "client/up-onlline-clienti.png",
  //   link:
  //     "https://upromania.ro/companii/card-cultural/",
  //   category: "Banner",
  //   action: "Click",
  //   label: "campanie_card_cultura",
  // },
];
